export default {
  init() {
    
  },
  finalize() {
    $('.job-title-field input').prop('value', $('.job-title').html());
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateJobApply.js